@if (!done) {
  <div class="restaurant-loader">
    <div class="loader">
      <fa-icon [icon]="faUtensils" [spin]="true"></fa-icon>
    </div>
  </div>
}

<div class="main-container" [class.hidden]="selectedProduct || cartOpen || billOpen || !ss">
  <div class="logo-container">
    @if (logoPath) {
      <img [src]="logoPath"/>
    }
  </div>
  @if (!selectedDmenu) {
    <ul class="dmenus">
      @for (dmenu of dmenus; track dmenu) {
        <li (click)="selectedDmenu = dmenu">
          <img class="dmenu-img" [src]="dmenu.aws_mini_picture_path || (serverUrl + dmenu.picture.url) || (serverUrl + '/default.png')"/>
          {{dmenu.name}}
        </li>
      }
    </ul>
  }
  @if (selectedDmenu) {
    <ul class="pcategories">
      @for (pcat of selectedDmenu.pcategories; track pcat) {
        <li class="pcategory">
          <div (click)="togglePcategory(pcat)">
            {{pcat.delivery_name || pcat.name}}
            <fa-icon [icon]="!pcat.user_hid ? faChevronUp : faChevronDown"></fa-icon>
          </div>
          @if (pcat.user_hid == false) {
            <div class="products">
              @for (prod of pcat.products; track prod) {
                <div class="product" (click)="selectProduct(prod)">
                  <img class="prod-image" [src]="prod.aws_mini_picture_path || (serverUrl + prod.picture_path.url) || (serverUrl + '/default.png')"/>
                  <div class="prod-name">
                    {{prod.delivery_name || prod.name}} {{prod.price | currency:'BRL'}}
                    <br/>
                    <div class="prod-desc">{{prod.description}}</div>
                  </div>
                </div>
              }
            </div>
          }
        </li>
      }
    </ul>
  }
</div>

@if (!selectedProduct) {
  <div class="navbar-bottom">
    <div class="nav-bot-opt" (click)="navBack()">
      @if (selectedDmenu || cartOpen || billOpen) {
        <fa-icon [icon]="faArrowLeft" size="2x"></fa-icon>
      }
    </div>
    <div class="nav-bot-opt" (click)="navCart()">
      @if (!selectedProduct) {
        <fa-icon [icon]="faCartShopping" size="2x"></fa-icon>
      }
      @if (cart.n_items > 0) {
        <span class="badge badge-pill badge-danger cart-badge">{{cart.n_items}}</span>
      }
    </div>
    <div class="nav-bot-opt" (click)="navBill()">
      <fa-icon [icon]="faClipboardList" size="2x"></fa-icon>
      @if (pendingItems.length > 0) {
        <span class="badge badge-pill badge-danger cart-badge">{{pendingItems.length}}</span>
      }
    </div>
  </div>
}

@if (selectedProduct) {
  <app-selected-product
    [product]="selectedProduct"
    (onClose)="selectedProduct = null"
    (onAdd)="addProduct($event)">
  </app-selected-product>
}
@if (cartOpen) {
  <app-sscart [sending]="sendingOrder" (onSend)="sendCart($event)" (onClose)="closeCart()"></app-sscart>
}
@if (billOpen) {
  <app-ssbill [selfservice]="ss" (onClose)="closeBill()"></app-ssbill>
}